import { render } from "./NoteSurvey.vue?vue&type=template&id=5a9dbde9&scoped=true"
import script from "./NoteSurvey.vue?vue&type=script&lang=js"
export * from "./NoteSurvey.vue?vue&type=script&lang=js"

import "./NoteSurvey.vue?vue&type=style&index=0&id=5a9dbde9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9dbde9"]])

export default __exports__